import fetch from "isomorphic-fetch";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

type ConfirmHoursTypesParams = {
    alias?: string;
    organisationId: string;
};
export function confirmHoursTypes(params: ConfirmHoursTypesParams) {
    return fetch(
        withAccountAuthHeaders(
            `${apiConf.BACK_URL}/organisations/${params.organisationId}/confirm_hours-types`,
            { method: `PUT` },
        ),
    );
}
